import { autoinject, customElement, PLATFORM, useView } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase, SortDirection, Sorting } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/api/api';
import { IQueryLoadOptions } from 'app/shared/lib/api/api-types';
import { CaseService } from 'app/cm/services/case-service';
import * as CM from 'app/cm/models/essette-api';

@autoinject()
abstract class CaseCheckedOutIconBase extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.objectNull({ changeHandler: 'reload' })
    protected case: CM.Case | null = null;

    protected checkouts: CM.CaseCheckoutHistory[] = [];

    protected abstract showAsIndicator: boolean;
    protected abstract showNotCheckedOut: boolean;
    protected isCMOfflineEnabled: boolean = false;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly caseService: CaseService,
        ...rest: any[]) {

        super(...rest);
    }

    protected bind(): void {
        this.isCMOfflineEnabled = this.env.config.integrations.includes('cm-offline');

        if(this.isCMOfflineEnabled) {
            this.reload();
        }
    }

    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    public async reload(): Promise<void> {
        await this.loadCaseCheckouts();
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadCaseCheckouts(): Promise<void> {
        if(!this.case?.id) return;

        const sorting = new Sorting();
        sorting.add({
            reference: 'metadata.started.timestamp',
            direction: SortDirection.Ascending
        });

        const options: Partial<IQueryLoadOptions> = {
            all: true,
            sorting: sorting
        };

        const includes = ['metadata.started.byUser'];
        const fields = ['metadata.started.byUser.description', 'metadata.started.timestamp'];

        try {
            this.state.beginLoad();

            const response = await this.caseService.loadCaseCheckoutHistory(this.case.id, options, includes, fields);
            this.checkouts = response.results;
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}

@customElement('case-checked-out-icon-indicator')
@useView(PLATFORM.moduleName('./case-checked-out-icon.html'))
export class CaseCheckedOutIconIndicator extends CaseCheckedOutIconBase {
    showAsIndicator = true;
    showNotCheckedOut = false;
}

@customElement('case-checked-out-icon-bubble')
@useView(PLATFORM.moduleName('./case-checked-out-icon.html'))
export class CaseCheckedOutIconBubble extends CaseCheckedOutIconBase {
    showAsIndicator = false
    showNotCheckedOut = true;
}
